type Props = {
  size?: number;
  color?: string;
};
const IconMemo = ({ size = 24, color = '#6F6F6F' }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 0H1.50003C1.1022 0 0.72067 0.158035 0.439366 0.43934C0.158061 0.720644 2.61181e-05 1.10218 2.61181e-05 1.5V16.5C-0.00166874 16.7859 0.079157 17.0662 0.232808 17.3074C0.386459 17.5485 0.60641 17.7401 0.866276 17.8594C1.06486 17.9516 1.28109 17.9996 1.50003 18C1.85215 17.9992 2.1926 17.8736 2.46096 17.6456C2.46544 17.6427 2.46953 17.6392 2.47315 17.6353L5.4844 15H18C18.3979 15 18.7794 14.842 19.0607 14.5607C19.342 14.2794 19.5 13.8978 19.5 13.5V1.5C19.5 1.10218 19.342 0.720644 19.0607 0.43934C18.7794 0.158035 18.3979 0 18 0ZM18 13.5H5.4844C5.13117 13.4998 4.78922 13.6243 4.51878 13.8516L4.50753 13.8619L1.50003 16.5V1.5H18V13.5Z"
        fill={color}
      />
    </svg>
  );
};

export default IconMemo;
